import React from 'react';
import { AlertTriangleIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, offer, urgency } from '../data/content';
interface FinalCtaProps {
  showUrgency?: boolean;
}
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-77" data-mp="15caurazkkb7u">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-78" data-mp="1jd51lp6yy44e">
        {showUrgency && <div className="mx-auto max-w-4xl text-center" data-id="element-79" data-mp="1jasekxmct3kh">
            <p className="inline-flex items-center gap-2 rounded-xl bg-red-50 px-4 py-2.5 text-sm font-extrabold uppercase tracking-wider text-red-600 ring-1 ring-red-100" data-id="element-80" data-mp="1ed8uhh2z5wkm">
              <AlertTriangleIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-81" data-mp="1o3lhdfy9i1tx" />
              {urgency.finalBadge}
            </p>
            <h2 className="mt-6 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-82" data-mp="22462iirng9ql">
              {urgency.priceNote}
            </h2>
          </div>}

        <div className="mx-auto mt-10 max-w-lg rounded-2xl bg-white p-8 text-center shadow-lg ring-2 ring-blue-600" data-id="element-83" data-mp="n6w4cre2zc8i">
          <h3 className="text-lg font-extrabold uppercase leading-snug tracking-tight text-slate-900" data-id="element-84" data-mp="s4xn1b7lh9jg">
            {offer.name}
          </h3>
          <p className="mt-2 text-blue-900/70" data-id="element-85" data-mp="123ekmr11gmeh">{offer.summary}</p>
          <p className="mt-6" data-id="element-86" data-mp="120sfsz5j8kzy">
            <span className="block text-base text-blue-900/45 line-through" data-id="element-87" data-mp="16503qu461wx4">
              {offer.listPrice}
            </span>
            <span className="text-4xl font-extrabold tracking-tight text-slate-900 md:text-5xl" data-id="element-88" data-mp="1b28p13km2h2l">
              {offer.price}
              <span className="ml-2 text-lg font-semibold text-blue-900/55" data-id="element-89" data-mp="1fv1q9hgvf79x">{offer.currency}</span>
            </span>
          </p>
          <div className="mt-7" data-id="element-90" data-mp="1psfumipis5lv">
            <CtaButton size="lg" className="w-full" href={checkoutUrl} data-id="element-91" data-mp="1pth7msq3j268">
              {offer.cta}
            </CtaButton>
          </div>
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-92" data-mp="1tryinncn0wsx">
            <li className="inline-flex items-center gap-1.5" data-id="element-93" data-mp="3lvuedsl5d54r">
              <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-94" data-mp="3lxf9bjbdiq35" /> Pagamento sicuro
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-95" data-mp="3jpgi9cdcdme">
              <ZapIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-96" data-mp="3uvh61mo2qwkm" /> Accesso immediato
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-97" data-mp="de7qfw8dp5en">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-98" data-mp="8hhara0hkbtr" /> Garanzia
              di 7 giorni
            </li>
          </ul>
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-3xl" data-id="element-99" data-mp="me4hg4i8qgcv">
          Il tuo prossimo esame ha già una data. Il tuo modo di prepararti può cambiare da oggi.
        </p>
      </div>
    </section>;
}